import { render, staticRenderFns } from "./unlock-info.vue?vue&type=template&id=13186956&scoped=true"
import script from "./unlock-info.vue?vue&type=script&setup=true&lang=js"
export * from "./unlock-info.vue?vue&type=script&setup=true&lang=js"
import style0 from "./unlock-info.vue?vue&type=style&index=0&id=13186956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13186956",
  null
  
)

export default component.exports